<section class="grid" role="region" aria-labelledby="client-details-heading">
	<section class="column" role="region" aria-labelledby="personal-data-heading">
		<h3 id="personal-data-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">person</mat-icon>
			{{ 'base.field.group.personal_data' | transloco }}
		</h3>

		<section class="info-row">
			<div class="name-column">
				<strong>{{ client()?.firstName ? `${client()?.firstName},` : '' }}</strong>
				<strong>{{ client()?.name }}</strong>
			</div>
			<section class="data-column">
				<p [attr.aria-label]="'base.field.date_of_birth' | transloco">
					<strong>{{ 'global_search.born' | transloco }}</strong>
					{{ isValidDate(client()?.dateOfBirth) ? (client()?.dateOfBirth | date: dateDisplayFormat) : '-' }}
				</p>
				<p>
					<strong>{{ 'global_search.case_owner' | transloco }}</strong>

					@if (!client()?.consultant) {
						-
					} @else {
						{{ client()?.consultant?.firstName }}, {{ client()?.consultant?.name }} -
						{{ client()?.consultant?.integrationServiceOfficeName }}
					}
				</p>
			</section>
		</section>
	</section>
</section>
